import { put, call, takeLatest, select } from 'redux-saga/effects';

import { MAIN_ROUTES } from 'consts';
import { updateTopic } from 'services/story';
import { AsyncAction } from 'types/Action';
import { Store } from 'types/store/Store';
import {
  UpdateStoryTopicMeta,
  UpdateStoryTopicPayload,
} from 'types/store/UpdateStoryTopic';
import navigationService from 'utils/navigationService';

import { updateStoryTopicActions } from '../actions';

function* updateStoryTopicRequest(
  action: AsyncAction<UpdateStoryTopicMeta, UpdateStoryTopicPayload>,
): any {
  const state: Store = yield select();
  if (state.auth.token) {
    try {
      const { data } = yield call(updateTopic, action.meta, state.auth.token);
      yield put(updateStoryTopicActions.success(data));
    } catch (e: any) {
      if (e.response.status === 404) {
        yield call(navigationService.goTo, MAIN_ROUTES.NOT_FOUND);
      } else {
        yield put(updateStoryTopicActions.failed(e.message));
      }
    }
  }
}

// function* updateStoryTopicSuccess(action: AsyncAction<UpdateStoryTopicMeta, UpdateStoryTopicPayload>): any {
//   yield put()
// }

function* updateStoryTopicWatcher(): any {
  yield takeLatest(updateStoryTopicActions.REQUEST, updateStoryTopicRequest);
  // yield takeLatest(updateStoryTopicActions.SUCCESS, updateStoryTopicSuccess);
}

export default updateStoryTopicWatcher;
